import { render, staticRenderFns } from "./PurchaseDuoExpectedPerBu.vue?vue&type=template&id=0f6085be&"
import script from "./PurchaseDuoExpectedPerBu.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoExpectedPerBu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports